import React,{useEffect,useState} from 'react';

// Explicit, temporary local test surface. Hidden by default; no microphone
// read, identity or permission is fabricated. Uses the app's normal submitter.
export default function AriaTranscriptTest({enabled,onSubmit}) {
 const [open,setOpen]=useState(false),[text,setText]=useState('');
 useEffect(()=>{
  if(!enabled) return;
  const key=event=>{
   if(event.ctrlKey && event.shiftKey && event.key.toLowerCase()==='y') {
    event.preventDefault();setOpen(value=>!value);
   }
  };
  window.addEventListener('keydown',key);return()=>window.removeEventListener('keydown',key);
 },[enabled]);
 if(!enabled || !open) return null;
 return <div role="dialog" aria-label="Transcript test" style={{position:'fixed',zIndex:2147483000,left:'50%',top:'20%',transform:'translateX(-50%)',width:'min(540px,90vw)',padding:22,borderRadius:16,background:'#152331',color:'#fff',boxShadow:'0 12px 50px #0009'}}>
  <h2 style={{margin:'0 0 10px'}}>Transcript test</h2>
  <p style={{fontSize:14}}>Text input through Aria’s normal router, or a structured action contract such as {JSON.stringify({name:'earth.search',query:'Topeka, Kansas'})}. Same permissions and execution guards. This does not test microphone capture. Paid conversation calls are blocked.</p>
  <form onSubmit={event=>{event.preventDefault();const value=text.trim();if(!value)return;setText('');setOpen(false);onSubmit(value);}}>
   <textarea autoFocus aria-label="Test transcript" value={text} onChange={event=>setText(event.target.value)} rows={4} style={{width:'100%',boxSizing:'border-box',padding:12,fontSize:16,borderRadius:8}} />
   <div style={{display:'flex',gap:12,marginTop:12}}>
    <button type="submit">Send test transcript</button>
    <button type="button" onClick={()=>setOpen(false)}>Close</button>
   </div>
  </form>
 </div>;
}
